import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS, type Lang } from "@shared";
import { currentLang, setLang } from "../i18n";

/**
 * Bascule de langue, accessible depuis la connexion et les reglages
 * (CLAUDE.md section 6). Boutons larges : la cible est un jeune de 6 ans.
 */
export default function LanguageSwitcher() {
  const { t } = useTranslation();
  const active = currentLang();

  return (
    <nav className="lang-switch" aria-label={t("language.label")}>
      {SUPPORTED_LANGS.map((lang: Lang) => (
        <button
          key={lang}
          type="button"
          className="lang-switch__button"
          aria-current={lang === active ? "true" : undefined}
          onClick={() => {
            void setLang(lang);
          }}
        >
          {t(`language.${lang}`)}
        </button>
      ))}
    </nav>
  );
}
